module.exports = __webpack_public_path__ + "img/album02_02.3af6bc9b.jpg";